import { useNavigate } from "react-router-dom";

import { Card, CardActionArea, CardActions, CardMedia, CardContent, Typography } from '@mui/material';

const ArticalCardSearch = ({ title, description, path, date }) => {
    const navigate = useNavigate();

    const getCleanDescription = (description) => {
        let d = description.trim();
        d = description.replaceAll('<br><br>', '<br>');
        if (d.startsWith('<br>')) d = d.substring(4);
        return d;
    }

    return (
        <Card sx={{ boxShadow: 2 }} className="article-card-search">
            <CardActionArea onClick={() => { navigate(`/articles/${path}`); }}>
                <CardContent>
                    <Typography variant="h6" component="div" sx={{ fontWeight: '400', fontSize: '0.8rem', letterSpacing: 'normal', lineHeight: 1.1, fontFamily: 'Merriweather, serif !important' }}>
                        {new Date(date).toLocaleDateString()}
                    </Typography>
                    <Typography variant="h6" component="div" sx={{ fontWeight: '800', fontSize: '1.4rem', letterSpacing: 'normal', lineHeight: 1.2, fontFamily: 'Merriweather, serif !important', mt: 1 }}>
                        {title}
                    </Typography>
                    <Typography sx={{
                        mt: 2,
                        fontSize: '1rem',
                        fontFamily: 'Merriweather, serif !important',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '3',
                        WebkitBoxOrient: 'vertical'
                    }} variant="body2" dangerouslySetInnerHTML={{ __html: getCleanDescription(description) }}>
                    </Typography>
                </CardContent>
                <CardActions sx={{ pt: 0 }}>
                    <Typography variant="button" component="a" sx={{ color: '#1976d2', ml: 2, fontFamily: 'Merriweather, serif !important' }}>
                        Pour lire l'article
                    </Typography>
                </CardActions>
            </CardActionArea>
        </Card>
    )
}

export default ArticalCardSearch;